import { Badge } from '@rewardops/ui'
import { CustomLabel } from '@rewardops/utils'

import { useApi } from '~/components/hooks/use-api'

export const LabelBadge = ({
  className = '',
  label,
}: {
  className?: string
  label: CustomLabel | null
}) => {
  const { tenant } = useApi()

  if (!label) return null

  return (
    <div>
      <Badge
        id={label?.key ?? label?.name}
        className={`h-5 rounded-sm px-2 py-2 text-xs font-normal text-white ${className}`}
        style={{
          backgroundColor: tenant.styleVariant?.label?.color,
        }}
      >
        {label.name}
      </Badge>
    </div>
  )
}
